module.exports = __webpack_public_path__ + "img/3.2735a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = U+2z
// module chunks = 1